import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';

export default function Footer() {
  const { t, language } = useLanguage();

  return (
    <footer className="border-t border-border bg-muted/30 py-16">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <h3 className="font-semibold text-foreground mb-4">Med AI Explorer</h3>
            <p className="text-sm text-muted-foreground max-w-md leading-relaxed">
              {t('footer.description')}
            </p>
          </div>
          
          <div>
            <h4 className="font-medium text-foreground mb-4 text-sm">{t('footer.navigation')}</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/search" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  {t('nav.solutions')}
                </Link>
              </li>
              <li>
                <Link to="/platforms" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  {t('nav.platforms')}
                </Link>
              </li>
              <li>
                <Link to="/insights" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  {t('nav.insights')}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  {language === 'fr' ? 'À propos' : 'About'}
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-medium text-foreground mb-4 text-sm">{t('footer.vendors')}</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/auth" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  {t('auth.login')}
                </Link>
              </li>
              <li>
                <Link to="/vendor/submit-solution" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  {t('vendor.submitSolution')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-medium text-foreground mb-4 text-sm">{t('footer.contact')}</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/contact" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  {language === 'fr' ? 'Nous contacter' : 'Contact Us'}
                </Link>
              </li>
              <li>
                <a href="mailto:contact@medaiexplorer.com" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  contact@medaiexplorer.com
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="mt-16 pt-8 border-t border-border">
          <p className="text-xs text-muted-foreground text-center">
            {new Date().getFullYear()} Med AI Explorer. {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>
  );
}
